import { TrackingMetadata } from '../types/metadata';
import { TrackingProvider } from '../types/providers';
import { TrackingEvent } from '../types/tracking-event';

/**
 * Simple provider that logs events to the console
 * Useful for development and debugging
 */
export class ConsoleProvider implements TrackingProvider {
  name = 'console-provider';

  receivedEvent(event: TrackingEvent, metadata: TrackingMetadata): void {
    console.log(`[Tracking] ${event.type}`, event, metadata);
  }
}
